var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "main_menu/users") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "main_menu/users",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58,40.5 C53.679,40.5 49.817,42.46 47.249,45.537 L42,41.945 L42,33 L38,33 L38,41.946 L32.751,45.537 C30.183,42.46 26.321,40.5 22,40.5 C14.268,40.5 8,46.768 8,54.5 C8,62.232 14.268,68.5 22,68.5 C29.732,68.5 36,62.232 36,54.5 C36,52.526 35.587,50.65 34.85,48.947 L40,45.423 L45.15,48.947 C44.413,50.65 44,52.526 44,54.5 C44,62.232 50.268,68.5 58,68.5 C65.732,68.5 72,62.232 72,54.5 C72,46.768 65.732,40.5 58,40.5",
    id: "Fill-41",
    fill: "#9A9B9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54,23 C54,30.732 47.732,37 40,37 C32.268,37 26,30.732 26,23 C26,15.268 32.268,9 40,9 C47.732,9 54,15.268 54,23",
    id: "Fill-42",
    fill: "#E64C29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40,22 C42.21,22 44,20.21 44,18 C44,15.79 42.21,14 40,14 C37.79,14 36,15.79 36,18 C36,20.21 37.79,22 40,22 M40,24 C37.469,24 35.135,24.537 33,25.587 L33,31 L47,31 L47,25.587 C44.865,24.537 42.531,24 40,24",
    id: "Fill-43",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58,53 C60.21,53 62,51.21 62,49 C62,46.79 60.21,45 58,45 C55.79,45 54,46.79 54,49 C54,51.21 55.79,53 58,53 M58,55 C55.469,55 53.135,55.537 51,56.587 L51,62 L65,62 L65,56.587 C62.865,55.537 60.531,55 58,55",
    id: "Fill-44",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,53 C24.21,53 26,51.21 26,49 C26,46.79 24.21,45 22,45 C19.79,45 18,46.79 18,49 C18,51.21 19.79,53 22,53 M22,55 C19.469,55 17.135,55.537 15,56.587 L15,62 L29,62 L29,56.587 C26.865,55.537 24.531,55 22,55",
    id: "Fill-45",
    fill: "#FFFFFF"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.a6b81e2d19383ae17a8b4c0919b58d70.svg";
export { ForwardRef as ReactComponent };